import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Detecta',
    desc: 'Aplica el Escáner de 3 Segundos en tu próxima compra para limpiar tu despensa de químicos y falsos alimentos saludables.'
  }, {
    num: '02',
    title: 'Infiltra',
    desc: 'Sigue el Menú Blindado para introducir nutrientes esenciales sin resistencia, usando nuestras técnicas de camuflaje.'
  }, {
    num: '03',
    title: 'Observa',
    desc: 'En menos de 14 días notarás cambios reales en su nivel de energía, su humor estable y su calidad de sueño.'
  }];
  return <section className="py-14 bg-white" data-id="element-63">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-64">
        <FadeIn data-id="element-65">
          <div className="text-center mb-10" data-id="element-66">
            <h2 className="text-3xl md:text-4xl font-bold text-ink mb-6" data-id="element-67">
              Tu Plan de Acción en 3 Pasos
            </h2>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-68">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-forest/10" data-id="element-69" />

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative z-10" data-id="element-70">
              <div className="flex flex-col items-center text-center" data-id="element-71">
                <div className="w-24 h-24 bg-cream rounded-full flex items-center justify-center border-4 border-white shadow-sm mb-6" data-id="element-72">
                  <span className="text-3xl font-extrabold text-leaf" data-id="element-73">
                    {step.num}
                  </span>
                </div>
                <h3 className="text-2xl font-bold text-ink mb-4" data-id="element-74">
                  {step.title}
                </h3>
                <p className="text-ink/70 leading-relaxed" data-id="element-75">{step.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}